import styled from "styled-components";
import { CommonFooterButton } from "../../common/CommonFooterButton";
import { useSelector } from "react-redux";
import { arrayRemove, doc, updateDoc } from "firebase/firestore";
import { useCallback, useMemo } from "react";
import { db } from "../../firebase";

import DavinciHooks from "../davinciCode/DavinciHooks";
import LandmineHooks from "../landmine/LandmineHooks";
import HalligalliHooks from "../halligalli/HalligalliHooks";
import FakeCardHooks from "../fakeCard/FakeCardHooks";

function getRandomConsonants() {
  const consonants = [
    "ㄱ",
    "ㄴ",
    "ㄷ",
    "ㄹ",
    "ㅁ",
    "ㅂ",
    "ㅅ",
    "ㅇ",
    "ㅈ",
    "ㅊ",
    "ㅋ",
    "ㅌ",
    "ㅍ",
    "ㅎ",
  ];

  const randomIndex1 = Math.floor(Math.random() * consonants.length);
  const randomIndex2 = Math.floor(Math.random() * consonants.length);

  // 선택된 자음 반환
  return [consonants[randomIndex1], consonants[randomIndex2]];
}

const wordTargets = {
  훈민정음: "wordMatchs",
  끝말잇기: "epilogueMatchs",
};

const WordGameFooter = () => {
  const { gameMode, roomId, wordMatchs, epilogueMatchs } = useSelector(
    state => state.GameSlice
  );
  const listArr = useMemo(() => {
    return gameMode === "훈민정음" ? wordMatchs : epilogueMatchs;
  }, [gameMode, wordMatchs, epilogueMatchs]);

  const InitialHandler = () => {
    const docRef = doc(db, "game", `room${roomId}`);

    updateDoc(docRef, {
      initialConsonant: getRandomConsonants().join(""),
    });
  };
  const DeleteLastWord = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);
    const target = wordTargets[gameMode];
    let removeArr = [...listArr];
    if (removeArr[0]) {
      removeArr.pop();
    }
    updateDoc(docRef, {
      [target]: removeArr,
    });
  }, [roomId, listArr, gameMode]);

  const ResetHandler = useCallback(
    async target => {
      if (roomId) {
        const docRef = doc(db, "game", `room${roomId}`);
        await updateDoc(docRef, {
          [target]: [],
          initialConsonant: "",
        });
      }
    },
    [roomId]
  );

  return (
    <FooterWrap>
      <CommonFooterButton onClick={InitialHandler}>
        자음 추출
      </CommonFooterButton>
      <CommonFooterButton onClick={DeleteLastWord}>되돌리기</CommonFooterButton>
      <CommonFooterButton onClick={() => ResetHandler(wordTargets[gameMode])}>
        초기화
      </CommonFooterButton>
    </FooterWrap>
  );
};

const OmokFooter = () => {
  const { boardArr, roomId } = useSelector(state => state.GameSlice);

  const BackHandler = useCallback(async () => {
    const docRef = doc(db, "game", `room${roomId}`);
    const removeValue = boardArr[boardArr.length - 1];
    await updateDoc(docRef, {
      board: arrayRemove(removeValue),
    });
  }, [boardArr, roomId]);

  const ResetHandler = useCallback(async () => {
    const docRef = doc(db, "game", `room${roomId}`);
    await updateDoc(docRef, {
      board: [],
    });
  }, [roomId]);

  return (
    <FooterWrap>
      <CommonFooterButton onClick={BackHandler}>무르기</CommonFooterButton>
      <CommonFooterButton onClick={ResetHandler}>초기화</CommonFooterButton>
    </FooterWrap>
  );
};

const DavinciFooter = () => {
  const {
    JoinDavinci,
    ExitDavinci,
    ResetGame,
    StartDavinciCode,
    CardConfirm,
    SubmitCard,
    NextTurn,
    OpenCard,
  } = DavinciHooks();

  const {
    davinciCode: { davinciCodeUsers, gameStatus, turnStep, turnUser },
  } = useSelector(state => state.GameSlice);

  const { userId } = useSelector(state => state.LoginInfoSlice);

  const checkTurn = useMemo(
    () => turnUser.userId === userId,
    [turnUser, userId]
  );

  const checkIncludes = useMemo(() => {
    return davinciCodeUsers.find(i => i?.userId === userId);
  }, [userId, davinciCodeUsers]);

  const stepButtonList = {
    0: [
      <CommonFooterButton key={`ConfirmButton`} onClick={CardConfirm}>
        확정
      </CommonFooterButton>,
    ],
    1: [
      <CommonFooterButton key={`SubmitButton`} onClick={SubmitCard}>
        추리
      </CommonFooterButton>,
    ],
    2: [
      <CommonFooterButton key={`AddSubmitButton`} onClick={SubmitCard}>
        추리
      </CommonFooterButton>,
      <CommonFooterButton key={`NextTurnButton`} onClick={() => NextTurn()}>
        턴 넘기기
      </CommonFooterButton>,
    ],
    3: [
      <CommonFooterButton key={`OpenButton`} onClick={OpenCard}>
        공개
      </CommonFooterButton>,
    ],
  };
  return gameStatus ? (
    turnStep === 4 ? (
      <CommonFooterButton key={`resetButton`} onClick={ResetGame}>
        초기화
      </CommonFooterButton>
    ) : (
      checkTurn && <FooterWrap>{stepButtonList[turnStep]}</FooterWrap>
    )
  ) : (
    <FooterWrap>
      {checkIncludes ? (
        <CommonFooterButton onClick={() => ExitDavinci()}>
          탈퇴
        </CommonFooterButton>
      ) : (
        <CommonFooterButton onClick={() => JoinDavinci()}>
          참여
        </CommonFooterButton>
      )}
      <CommonFooterButton onClick={() => StartDavinciCode()}>
        게임 시작
      </CommonFooterButton>
    </FooterWrap>
  );
};
const LandmineFooter = () => {
  const {
    landmine: { gameStatus, turnUser, landmineUsers },
  } = useSelector(state => state.GameSlice);
  const {
    JoinLandmine,
    ExitLandmine,
    ResetGame,
    SizeHandler,
    StartLandmine,
    MineHandler,
  } = LandmineHooks();

  const { userId } = useSelector(state => state.LoginInfoSlice);
  const checkInclude = useMemo(
    () => landmineUsers.find(i => i?.userId === userId),
    [landmineUsers, userId]
  );

  return !gameStatus ? (
    <FooterWrap>
      {!checkInclude ? (
        <CommonFooterButton onClick={JoinLandmine}>참여</CommonFooterButton>
      ) : (
        <CommonFooterButton onClick={ExitLandmine}>탈퇴</CommonFooterButton>
      )}
      <CommonFooterButton onClick={SizeHandler}>크기변경</CommonFooterButton>
      <CommonFooterButton onClick={MineHandler}>개수변경</CommonFooterButton>

      <CommonFooterButton onClick={StartLandmine}>시작</CommonFooterButton>
    </FooterWrap>
  ) : (
    <FooterWrap>
      <CommonFooterButton onClick={ResetGame}>초기화</CommonFooterButton>
    </FooterWrap>
  );
};

const HalligalliFooter = () => {
  const {
    halligalli: { gameStatus, halligalliUsers },
  } = useSelector(state => state.GameSlice);

  const { JoinHalligalli, ExitHalligalli, StartHalligalli, ResetGame } =
    HalligalliHooks();

  const { userId } = useSelector(state => state.LoginInfoSlice);
  const checkInclude = useMemo(
    () => halligalliUsers.find(i => i?.userId === userId),
    [halligalliUsers, userId]
  );

  return !gameStatus ? (
    <FooterWrap>
      {checkInclude ? (
        <CommonFooterButton onClick={ExitHalligalli}>탈퇴</CommonFooterButton>
      ) : (
        <CommonFooterButton onClick={JoinHalligalli}>참여</CommonFooterButton>
      )}
      <CommonFooterButton onClick={StartHalligalli}>시작</CommonFooterButton>
    </FooterWrap>
  ) : (
    <FooterWrap>
      <CommonFooterButton onClick={ResetGame}>초기화</CommonFooterButton>
    </FooterWrap>
  );
};

const FooterWrap = styled.div`
  display: flex;
  gap: 4px;
`;

const FakeCardFooter = () => {
  const {
    fakeCard: { gameStatus, voteCount, turnStep, turnUser },
  } = useSelector(state => state.GameSlice);
  const { userId } = useSelector(state => state.LoginInfoSlice);
  const {
    JoinFakeCard,
    ExitFakeCard,
    ResetGame,
    StartFakeCard,
    SubmitCards,
    PassCard,
    OverCards,
    NotOverCard,
    BringCards,
    PassVote,
    ReturnSubmit,
    checkIncludes,
    liveCount,
  } = FakeCardHooks();

  // 1은 무조건 제출 (첫 턴), 2부터는 패스 or 제출
  // 패스는 남은 카드가 있을 경우에는 카드 한장 먹기, 없으면 그냥 패스

  const stepFooter = {
    1: (
      <FooterWrap>
        <CommonFooterButton onClick={SubmitCards}>제출</CommonFooterButton>
      </FooterWrap>
    ),
    2: (
      <FooterWrap>
        <CommonFooterButton onClick={SubmitCards}>제출</CommonFooterButton>
        <CommonFooterButton onClick={PassCard}>패스</CommonFooterButton>
        {liveCount === voteCount && (
          <CommonFooterButton onClick={PassVote}>라운드패스</CommonFooterButton>
        )}
      </FooterWrap>
    ),
    3: (
      <FooterWrap>
        <CommonFooterButton onClick={OverCards}>뒤집기</CommonFooterButton>
        <CommonFooterButton onClick={NotOverCard}>패스</CommonFooterButton>
      </FooterWrap>
    ),
    4: (
      <FooterWrap>
        <CommonFooterButton onClick={BringCards}>가져오기</CommonFooterButton>
      </FooterWrap>
    ),
    5: (
      <FooterWrap>
        <CommonFooterButton onClick={ReturnSubmit}>
          다음라운드
        </CommonFooterButton>
      </FooterWrap>
    ),
  };

  return !gameStatus ? (
    <FooterWrap>
      {checkIncludes ? (
        <CommonFooterButton onClick={ExitFakeCard}>탈퇴</CommonFooterButton>
      ) : (
        <CommonFooterButton onClick={JoinFakeCard}>참여</CommonFooterButton>
      )}
      <CommonFooterButton onClick={StartFakeCard}>게임 시작</CommonFooterButton>
    </FooterWrap>
  ) : (
    <FooterWrap>
      {turnUser?.userId === userId && stepFooter[turnStep]}
      <CommonFooterButton onClick={ResetGame}>초기화</CommonFooterButton>
    </FooterWrap>
  );
};

export const footers = {
  오목: <OmokFooter />,
  훈민정음: <WordGameFooter />,
  다빈치코드: <DavinciFooter />,
  지뢰찾기: <LandmineFooter />,
  할리갈리: <HalligalliFooter />,
  페이크카드: <FakeCardFooter />,
};
